module.exports = __webpack_public_path__ + "img/select-tick-red.93392a41.svg";